import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Check, X } from "react-feather";
import React, { useState } from "react";
import PasswordChecklist from "react-password-checklist";
import { Input } from "../FormLogin/styles";
import { ChecklistContainer, EyeContainer } from "./styles";

export const PasswordInput = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const newProps = { ...props };
  const newGroupProps = { ...newProps.groupProps };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  newGroupProps.className = `input-group ${newGroupProps.className}`;
  delete newProps.groupProps;
  newProps.type = showPassword ? "text" : "password";
  newProps.className = `form-control ${newProps.className}`;
  if (newProps.value) {
    newProps.className = `border-right-0 ${newProps.className}`;
  }

  return (
    <>
      <div {...newGroupProps}>
        <Input {...newProps} />
        {newProps.value ? (
          <EyeContainer>
            <span>
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} onClick={handleShowPassword} />
            </span>
          </EyeContainer>
        ) : (
          <></>
        )}
      </div>
      {newProps.onValidChange && newProps.value ? (
        <ChecklistContainer>
          <PasswordChecklist
            rules={["minLength", "specialChar", "number", "capital", "lowercase"]}
            minLength="8"
            value={newProps.value}
            onChange={newProps.onValidChange}
            messages={{
              capital: "Al menos una mayúsucula",
              lowercase: "Al menos una minúscula",
              minLength: "Más de 8 caracteres",
              number: "Al menos un número",
              specialChar: "Al menos un caracter especial ~`!#$%^&*@+=-[]';,{}|\":<>?.",
            }}
            iconComponents={{
              ValidIcon: <Check size={14} color="#EE3124" />,
              InvalidIcon: <X size={14} color="#EE3124" />,
            }}
            style={{
              fontSize: "11px",
            }}
          />
        </ChecklistContainer>
      ) : null}
    </>
  );
};
